import {useMutation} from '@tanstack/react-query';
import {useRef} from 'react';
import type {PrDispatchRequest} from '../../api/prdispatch';
import {prDispatchApi} from '../../api/prdispatch/client';
import {useWithAccessToken} from '../../auth/use-with-access-token';

export const useSubmitPrDispatch = () => {
    const payloadRef = useRef<PrDispatchRequest | null>(null);
    const submit = useWithAccessToken((config) =>
        prDispatchApi.submitPrDispatch(payloadRef.current!, undefined, config),
    );
    return useMutation({
        mutationFn: (payload: PrDispatchRequest) => {
            payloadRef.current = payload;
            return submit();
        },
    });
};
